const $body = $('body');
const $header = $('.header');
const $promo = $('.js-promo');

$(window).on('scroll', () => {
	const scrolled = $(window).scrollTop();

	if (scrolled > 400) {
		$body.addClass('is_header_sticky');
		$header.addClass('header_is_sticky');
		$promo.addClass('promo_is_sticky');
	} else {
		$body.removeClass('is_header_sticky');
		$header.removeClass('header_is_sticky');
		$promo.removeClass('promo_is_sticky');
	}
});
